/* Badge Buddy layout pack (BB placement rules), GENERATED - do not edit.
 *
 * Built by scripts/bb-layout/build-pack-asset.mjs from production's
 * data/bb_automation/bb_layout_pack.json (Odin workspace main 68747866, badge bottom rule, cap-height maximums).
 * The JSON between the next line and BB_LAYOUT_PACK_END is that file, byte for byte.
 *   rules_version  bb-placement-rules-v1
 *   pack_version   1
 *   json sha256    7d5b943c601fb608ac4e3a14a86294d12cd01cd7514053229fb00251b544e718
 * Font files the metrics were measured from:
 *   Minion Pro Bold  MinionPro-Bold.otf           sha256 a721c09db45c8887dc705f4ce0c7f89e1751d5caeea2b4916f652d8363a97332
 *   Futura Bold      bb-font-futura-bold.woff2    sha256 41c9dd1b859287e462d676a24bea6511a01926775b6940d962c7cf8f49617ca0
 *   Verdana          bb-font-verdana.woff2        sha256 d9c8ff474c9a40e244af0b31ea558c4b8f736c019b28b74e757880d6155d5293
 *   Rockwell         bb-font-rockwell.woff2       sha256 22d4a7f856e92985840cabc6bd08f5ffe2073e9edb0495c5a62e0e1aa4099406
 *   Arial            arial.ttf                    sha256 b3658eadae55e682b5f69eb64c439c1ecc8f196c0bb8d4756d145d13bc86476a
 * Read by assets/bb-layout-engine.js (window.BBLayout) through assets/custom-bb.js.
 */
window.BB_LAYOUT_PACK_SHA256 = "7d5b943c601fb608ac4e3a14a86294d12cd01cd7514053229fb00251b544e718";
window.BB_LAYOUT_PACK = {
 "schema": "bb-layout-pack",
 "pack_version": 1,
 "rules_version": "bb-placement-rules-v1",
 "features": [
  "per_line_fonts: optional font2 for Line 2 (default = font); every per-line measurement (width-fit sizing, ink extents, glyph offsets, missing glyphs, box/bleed geometry) uses that line's font; two matched lines in different fonts follow rules.mixed_font_equal_size (Simon 2026-10-10)",
  "enlarge: optional 'make it bigger' for two-line titles - the lines are sized on their own, exactly like an approved acronym line; offered only when a line grows by at least rules.enlarge_min_gain and no line shrinks or needs review (Simon 2026-10-10)",
  "badge_bottom: style 'bottom' with size_class BBOTTOM (dies H-BBOTTOM / V-BBOTTOM) - ink 2 mm from the top and bottom cuts and 5 mm from the side cuts, one line up to 77 pt, two lines keep the production line-1:line-2 ratio and each line is then capped at 45 pt on its own; block centred between the cuts, moved up when a descender would pass the 2 mm limit (rules.bottom; Simon 2026-10-12); the 77/45 pt maximums are capital heights of rules.bottom.max_reference_font, so other fonts get the point size that gives the same capital height"
 ],
 "generator": "scripts/bb_layout_pack_build.py",
 "rules": {
  "units": "inches unless the key says pt or mm; y measured UP from the bottom cut; x from the die centre",
  "min_font_pt": 15.0,
  "min_font_pt_with_acronym": 10.0,
  "mixed_font_equal_size": "point",
  "enlarge_min_gain": 0.1,
  "card": {
   "model": "CR80, flush: card top edge = Badge Buddy top edge (standard die)",
   "size_in": {
    "H": {
     "width": 3.375,
     "height": 2.125
    },
    "V": {
     "width": 2.125,
     "height": 3.375
    }
   },
   "corner_radius_in": 0.125,
   "margin_below_card_in": 0.03,
   "card_bottom_from_cut_in": {
    "H": 0.96875,
    "V": 1.125
   }
  },
  "strip": {
   "note": "XL strips use the standard strip bottom inset (XL bottom = standard bottom)",
   "bottom_inset_from_cut_in": {
    "H": 0.160014,
    "V": 0.120956
   },
   "height_in": {
    "H": 1.0,
    "V": 1.25
   },
   "width_in": {
    "H": 3.069444,
    "V": 1.875
   }
  },
  "box": {
   "name": "variant B",
   "single_line_inset_a_in": {
    "H": 0.0483,
    "V": 0.1265
   },
   "single_line_inset_b_per_in": {
    "H": 0.0723,
    "V": 0.0702
   },
   "two_line_bottom_inset_in": {
    "H": 0.082,
    "V": 0.153
   },
   "ink_gap_pt": {
    "H": 2.8,
    "V": 4.25
   },
   "descender_inset_share": 0.6,
   "shrink_step": 0.98,
   "shrink_max_steps": 80,
   "ceiling_tolerance_in": 1e-12
  },
  "bleed": {
   "side_margin_mm": 3.0,
   "bottom_margin_mm": 2.0,
   "colour_bleed_in": 0.125,
   "colour_top": "min(strip top, card bottom - colour_bleed_in)",
   "ink_gap_pt": {
    "H": 2.8,
    "V": 4.25
   },
   "search_lo_pt": 3.0,
   "search_hi_pt": 400.0,
   "search_iterations": 60,
   "tolerance_in": 1e-09
  },
  "bottom": {
   "name": "Badge Bottom rule (Simon 2026-10-12)",
   "size_class": "BBOTTOM",
   "top_bottom_margin_mm": 2.0,
   "side_margin_mm": 5.0,
   "max_font_pt": 77.0,
   "two_line_max_font_pt": 45.0,
   "max_reference_font": "Minion Pro Bold",
   "max_by": "cap_height",
   "two_line_cap": "each line on its own; the other line keeps its size",
   "ratio": "production_font_sizes of the orientation (STD sizing, approved-acronym rule)",
   "ink_gap_pt": {
    "H": 2.8,
    "V": 4.25
   },
   "search_lo_pt": 3.0,
   "search_hi_pt": 400.0,
   "search_iterations": 60,
   "tolerance_in": 1e-09
  },
  "measurement": {
   "ink_top": "max glyph y_max over the line (glyphs without outlines ignored)",
   "ink_bottom": "min glyph y_min over the line",
   "ink_x": "min/max of glyph x_min/x_max at pen positions from advance_units (no kerning)",
   "width": "sum of pdf_advance_milli_em / 1000 * font size (no kerning); used for sizing and centring",
   "cap_height": "y_max of 'H'",
   "per_line_font": "each line is measured in its own font (font for Line 1, font2 for Line 2)",
   "missing_glyph": "falls back to notdef metrics and sets needs_review"
  }
 },
 "dies": {
  "H-STD": {
   "spid": "SPID-000003",
   "die_width_in": 3.375,
   "die_height_in": 3.09375,
   "strip_width_in": 3.069444,
   "strip_height_in": 1.0,
   "production_strip_bottom_inset_in": 0.160014
  },
  "H-XL": {
   "spid": "SPID-000004",
   "die_width_in": 3.375,
   "die_height_in": 4.09375,
   "strip_width_in": 3.069444,
   "strip_height_in": 1.0,
   "production_strip_bottom_inset_in": 0.139993
  },
  "V-STD": {
   "spid": "SPID-000002",
   "die_width_in": 2.125,
   "die_height_in": 4.5,
   "strip_width_in": 1.875,
   "strip_height_in": 1.25,
   "production_strip_bottom_inset_in": 0.120956
  },
  "V-XL": {
   "spid": "SPID-000001",
   "die_width_in": 2.125,
   "die_height_in": 5.5,
   "strip_width_in": 1.875,
   "strip_height_in": 1.25,
   "production_strip_bottom_inset_in": 0.127573
  },
  "H-BBOTTOM": {
   "spid": "SPID-000006",
   "die_width_in": 3.5,
   "die_height_in": 1.3125,
   "strip_width_in": 3.5,
   "strip_height_in": 1.3125,
   "production_strip_bottom_inset_in": 0.0
  },
  "V-BBOTTOM": {
   "spid": "SPID-000005",
   "die_width_in": 2.375,
   "die_height_in": 1.3125,
   "strip_width_in": 2.375,
   "strip_height_in": 1.3125,
   "production_strip_bottom_inset_in": 0.0
  }
 },
 "sizing": {
  "H": {
   "badge_width_in": 3.0694,
   "title_inset_side_in": 0.0658,
   "title_height_in": 1.0,
   "width_padding_in": 0.1,
   "height_padding_in": 0.1,
   "two_line_height_share": 0.52,
   "reference_size_pt": 20.0,
   "max_font_single_pt": 105.0,
   "max_font_line1_pt": 45.0,
   "max_font_line2_pt": 45.0,
   "max_sum_font_pt": 85.0,
   "min_computed_size_pt": 0.5,
   "round_to_pt": 0.1
  },
  "V": {
   "badge_width_in": 1.875,
   "title_inset_side_in": 0.0585,
   "title_height_in": 1.25,
   "width_padding_in": 0.1,
   "height_padding_in": 0.1,
   "two_line_height_share": 0.52,
   "reference_size_pt": 20.0,
   "max_font_single_pt": 105.0,
   "max_font_line1_pt": 75.0,
   "max_font_line2_pt": 75.0,
   "max_sum_font_pt": 120.0,
   "min_computed_size_pt": 0.5,
   "round_to_pt": 0.1
  }
 },
 "approved_acronyms": [
  "APRN",
  "BSN",
  "CA",
  "CMA",
  "CNA",
  "CNS",
  "COTA",
  "CRNA",
  "DNP",
  "EMS",
  "EMT",
  "ER",
  "HHA",
  "HUC",
  "ICU",
  "LPN",
  "LVN",
  "MA",
  "MD",
  "MHW",
  "NA",
  "NP",
  "OT",
  "PA",
  "PCT",
  "PT",
  "PTA",
  "RCP",
  "RMA",
  "RN",
  "RRT",
  "ST",
  "UC"
 ],
 "fonts": {
  "Minion Pro Bold": {
   "file": "MinionPro-Bold.otf",
   "sha256": "a721c09db45c8887dc705f4ce0c7f89e1751d5caeea2b4916f652d8363a97332",
   "full_name": "Minion Pro Bold",
   "version": "Version 2.068;PS 2.000;hotconv 1.0.57;makeotf.lib2.0.21895",
   "units_per_em": 1000,
   "cap_height_units": 650,
   "notdef": [
    500,
    500,
    0,
    0,
    500,
    700
   ],
   "glyph_fields": [
    "advance_units",
    "pdf_advance_milli_em",
    "x_min",
    "y_min",
    "x_max",
    "y_max"
   ],
   "glyphs": {
    " ": [
     217,
     217,
     null,
     null,
     null,
     null
    ],
    "!": [
     285,
     285,
     59,
     -12,
     223,
     665
    ],
    "\"": [
     380,
     380,
     36,
     423,
     340,
     708
    ],
    "#": [
     500,
     500,
     21,
     15,
     468,
     614
    ],
    "$": [
     500,
     500,
     42,
     -71,
     462,
     689
    ],
    "%": [
     764,
     764,
     41,
     -37,
     725,
     650
    ],
    "&": [
     715,
     715,
     43,
     -14,
     732,
     664
    ],
    "'": [
     199,
     199,
     34,
     423,
     157,
     708
    ],
    "(": [
     352,
     352,
     76,
     -172,
     314,
     714
    ],
    ")": [
     352,
     352,
     38,
     -172,
     275,
     714
    ],
    "*": [
     405,
     405,
     32,
     306,
     372,
     665
    ],
    "+": [
     577,
     577,
     47,
     0,
     530,
     485
    ],
    ",": [
     254,
     254,
     35,
     -133,
     217,
     161
    ],
    "-": [
     342,
     342,
     41,
     194,
     302,
     265
    ],
    ".": [
     254,
     254,
     53,
     -12,
     201,
     140
    ],
    "/": [
     327,
     327,
     17,
     -45,
     304,
     665
    ],
    "0": [
     500,
     500,
     28,
     -12,
     472,
     635
    ],
    "1": [
     500,
     500,
     94,
     0,
     409,
     635
    ],
    "2": [
     500,
     500,
     33,
     0,
     473,
     635
    ],
    "3": [
     500,
     500,
     39,
     -12,
     454,
     635
    ],
    "4": [
     500,
     500,
     15,
     0,
     486,
     629
    ],
    "5": [
     500,
     500,
     38,
     -12,
     455,
     623
    ],
    "6": [
     500,
     500,
     28,
     -12,
     480,
     641
    ],
    "7": [
     500,
     500,
     39,
     -12,
     485,
     623
    ],
    "8": [
     500,
     500,
     32,
     -12,
     472,
     635
    ],
    "9": [
     500,
     500,
     24,
     -15,
     471,
     635
    ],
    ":": [
     254,
     254,
     55,
     -12,
     202,
     419
    ],
    ";": [
     254,
     254,
     38,
     -133,
     218,
     419
    ],
    "<": [
     548,
     548,
     53,
     0,
     497,
     506
    ],
    "=": [
     577,
     577,
     47,
     130,
     531,
     378
    ],
    ">": [
     548,
     548,
     54,
     0,
     497,
     506
    ],
    "?": [
     399,
     399,
     46,
     -12,
     362,
     665
    ],
    "@": [
     766,
     766,
     54.99499513752399,
     -100,
     725,
     577
    ],
    "A": [
     706,
     706,
     18,
     0,
     687,
     665
    ],
    "B": [
     637,
     637,
     35,
     0,
     593,
     650
    ],
    "C": [
     676,
     676,
     42,
     -15,
     660,
     665
    ],
    "D": [
     761,
     761,
     32,
     0,
     717,
     650
    ],
    "E": [
     581,
     581,
     26,
     0,
     571,
     650
    ],
    "F": [
     554,
     554,
     40,
     0,
     524,
     650
    ],
    "G": [
     727,
     727,
     44,
     -15,
     703,
     665
    ],
    "H": [
     783,
     783,
     35,
     0,
     746,
     650
    ],
    "I": [
     378,
     378,
     37,
     0,
     338,
     650
    ],
    "J": [
     366,
     366,
     20,
     -162,
     337,
     650
    ],
    "K": [
     703,
     703,
     37,
     0,
     699,
     650
    ],
    "L": [
     551,
     551,
     24,
     0,
     548,
     650
    ],
    "M": [
     888,
     888,
     17,
     0,
     860,
     650
    ],
    "N": [
     740,
     740,
     16,
     -10,
     724,
     650
    ],
    "O": [
     766,
     766,
     42,
     -15,
     725,
     664
    ],
    "P": [
     599,
     599,
     37,
     0,
     567,
     650
    ],
    "Q": [
     758,
     758,
     42,
     -167.7071647051041,
     734,
     665
    ],
    "R": [
     659,
     659,
     35,
     -9,
     660,
     650
    ],
    "S": [
     505,
     505,
     38,
     -15,
     472,
     665
    ],
    "T": [
     641,
     641,
     27,
     0,
     616,
     675
    ],
    "U": [
     729,
     729,
     29,
     -15,
     723,
     650
    ],
    "V": [
     711,
     711,
     15,
     -11,
     702,
     650
    ],
    "W": [
     979,
     979,
     13,
     -11,
     969,
     650
    ],
    "X": [
     693,
     693,
     8,
     0,
     700,
     650
    ],
    "Y": [
     655,
     655,
     16,
     0,
     646,
     650
    ],
    "Z": [
     619,
     619,
     29,
     0,
     607,
     675
    ],
    "[": [
     351,
     351,
     117,
     -162,
     302,
     704
    ],
    "\\": [
     332,
     332,
     28,
     -45,
     304,
     665
    ],
    "]": [
     351,
     351,
     49,
     -162,
     234,
     704
    ],
    "^": [
     559,
     559,
     53,
     213,
     506,
     623
    ],
    "_": [
     500,
     500,
     0,
     -125,
     500,
     -75
    ],
    "`": [
     400,
     400,
     80,
     489,
     240,
     679.439005318302
    ],
    "a": [
     466,
     466,
     30,
     -12,
     465,
     454
    ],
    "b": [
     534,
     534,
     7,
     -12,
     504,
     703
    ],
    "c": [
     422,
     422,
     29,
     -12,
     418,
     454
    ],
    "d": [
     547,
     547,
     29,
     -13,
     541,
     703
    ],
    "e": [
     437,
     437,
     30,
     -12,
     421,
     454
    ],
    "f": [
     331,
     331,
     22,
     0,
     403.2430050188443,
     703
    ],
    "g": [
     492,
     492,
     27,
     -244,
     498,
     454
    ],
    "h": [
     550,
     550,
     12,
     0,
     531,
     703
    ],
    "i": [
     295,
     295,
     28,
     0,
     285,
     657
    ],
    "j": [
     288,
     288,
     -22,
     -244,
     221,
     657
    ],
    "k": [
     513,
     513,
     9,
     -1,
     535,
     703
    ],
    "l": [
     278,
     278,
     10,
     0,
     270,
     703
    ],
    "m": [
     843,
     843,
     30,
     0,
     823,
     456
    ],
    "n": [
     566,
     566,
     26,
     0,
     549,
     456
    ],
    "o": [
     525,
     525,
     30,
     -12,
     496,
     454
    ],
    "p": [
     547,
     547,
     16,
     -230,
     517,
     464
    ],
    "q": [
     536,
     536,
     29,
     -230,
     534,
     454.00664437612113
    ],
    "r": [
     404,
     404,
     28,
     0,
     402,
     455
    ],
    "s": [
     383,
     383,
     40,
     -12,
     360,
     454
    ],
    "t": [
     339,
     339,
     16,
     -12,
     329,
     593
    ],
    "u": [
     555,
     555,
     28,
     -12,
     542,
     449
    ],
    "v": [
     465,
     465,
     -8,
     -11,
     483,
     442
    ],
    "w": [
     683,
     683,
     3,
     -11,
     699,
     442
    ],
    "x": [
     482,
     482,
     7,
     0,
     494,
     442
    ],
    "y": [
     465,
     465,
     -7,
     -245,
     483,
     442
    ],
    "z": [
     445,
     445,
     24,
     0,
     439,
     463
    ],
    "{": [
     357,
     357,
     56,
     -168,
     311,
     710
    ],
    "|": [
     270,
     270,
     93,
     -250,
     177,
     750
    ],
    "}": [
     357,
     357,
     47,
     -168,
     302,
     710
    ],
    "~": [
     577,
     577,
     52,
     182,
     529,
     322
    ],
    " ": [
     217,
     217,
     null,
     null,
     null,
     null
    ],
    "¡": [
     285,
     285,
     61,
     -220,
     225,
     458
    ],
    "¢": [
     500,
     500,
     46,
     5,
     454,
     615
    ],
    "£": [
     500,
     500,
     15.30099193390697,
     -27,
     490,
     635
    ],
    "¤": [
     500,
     500,
     18,
     87,
     471,
     563
    ],
    "¥": [
     500,
     500,
     6,
     0,
     489,
     623
    ],
    "¦": [
     270,
     270,
     93,
     -175,
     177,
     675
    ],
    "§": [
     482,
     482,
     43,
     -104,
     429.059159507889,
     643
    ],
    "¨": [
     400,
     400,
     30,
     519,
     370,
     652
    ],
    "©": [
     699,
     699,
     41,
     19,
     658,
     631
    ],
    "ª": [
     335,
     335,
     28,
     271,
     318,
     556
    ],
    "«": [
     456,
     456,
     47,
     32,
     412,
     416
    ],
    "¬": [
     577,
     577,
     47,
     101,
     531,
     375
    ],
    "­": [
     342,
     342,
     41,
     194,
     302,
     265
    ],
    "®": [
     319,
     319,
     28,
     394,
     294,
     659
    ],
    "¯": [
     400,
     400,
     75,
     542,
     325,
     614
    ],
    "°": [
     331,
     331,
     29,
     403,
     301,
     665
    ],
    "±": [
     577,
     577,
     47,
     0,
     530,
     550
    ],
    "²": [
     348,
     348,
     34,
     398,
     320,
     755
    ],
    "³": [
     348,
     348,
     39.79474981450549,
     390,
     305,
     756
    ],
    "´": [
     400,
     400,
     173,
     489,
     337,
     679.9866080841889
    ],
    "µ": [
     538,
     538,
     65,
     -244,
     538,
     455
    ],
    "¶": [
     519,
     519,
     39,
     -218,
     479,
     549
    ],
    "·": [
     254,
     254,
     52,
     157,
     203,
     311
    ],
    "¸": [
     400,
     400,
     138,
     -235,
     275,
     0
    ],
    "¹": [
     348,
     348,
     70,
     398,
     289,
     755
    ],
    "º": [
     369,
     369,
     25.946405772643615,
     270,
     341.01272528612077,
     556
    ],
    "»": [
     456,
     456,
     48,
     32,
     409,
     416
    ],
    "¼": [
     784,
     784,
     76,
     -40,
     708,
     648
    ],
    "½": [
     789,
     789,
     67,
     -40,
     725,
     648
    ],
    "¾": [
     789,
     789,
     72.79474981450548,
     -40,
     707,
     648
    ],
    "¿": [
     399,
     399,
     37,
     -220,
     353,
     458
    ],
    "À": [
     706,
     706,
     18,
     0,
     687,
     837
    ],
    "Á": [
     706,
     706,
     18,
     0,
     687,
     833
    ],
    "Â": [
     706,
     706,
     18,
     0,
     687,
     833
    ],
    "Ã": [
     706,
     706,
     18,
     0,
     687,
     806
    ],
    "Ä": [
     706,
     706,
     18,
     0,
     687,
     828
    ],
    "Å": [
     706,
     706,
     18,
     0,
     687,
     863
    ],
    "Æ": [
     882,
     882,
     -14,
     0,
     872,
     650
    ],
    "Ç": [
     676,
     676,
     41.99525091207818,
     -243,
     660,
     665
    ],
    "È": [
     581,
     581,
     26,
     0,
     571,
     837
    ],
    "É": [
     581,
     581,
     26,
     0,
     571,
     833
    ],
    "Ê": [
     581,
     581,
     26,
     0,
     571,
     833
    ],
    "Ë": [
     581,
     581,
     26,
     0,
     571,
     828
    ],
    "Ì": [
     378,
     378,
     34,
     0,
     338,
     837
    ],
    "Í": [
     378,
     378,
     37,
     0,
     347,
     833
    ],
    "Î": [
     378,
     378,
     37,
     0,
     338,
     833
    ],
    "Ï": [
     378,
     378,
     16,
     0,
     361,
     828
    ],
    "Ð": [
     760,
     760,
     38,
     0,
     718,
     650
    ],
    "Ñ": [
     740,
     740,
     16,
     -10,
     724,
     805
    ],
    "Ò": [
     766,
     766,
     42,
     -15,
     725,
     845
    ],
    "Ó": [
     766,
     766,
     42,
     -15,
     725,
     841
    ],
    "Ô": [
     766,
     766,
     42,
     -15,
     725,
     841
    ],
    "Õ": [
     766,
     766,
     42,
     -15,
     725,
     813
    ],
    "Ö": [
     766,
     766,
     42,
     -15,
     724,
     832
    ],
    "×": [
     577,
     577,
     58,
     10,
     519,
     483
    ],
    "Ø": [
     771,
     771,
     42,
     -52,
     729,
     697
    ],
    "Ù": [
     729,
     729,
     29,
     -15,
     723,
     837
    ],
    "Ú": [
     729,
     729,
     29,
     -15,
     723,
     833
    ],
    "Û": [
     729,
     729,
     29,
     -15,
     723,
     833
    ],
    "Ü": [
     729,
     729,
     29,
     -15,
     723,
     828
    ],
    "Ý": [
     655,
     655,
     16,
     0,
     646,
     833
    ],
    "Þ": [
     593,
     593,
     39,
     0,
     559,
     650
    ],
    "ß": [
     572,
     572,
     26,
     -12,
     548,
     704
    ],
    "à": [
     466,
     466,
     30,
     -12,
     465,
     679.439005318302
    ],
    "á": [
     466,
     466,
     30,
     -12,
     465,
     679.9866080841889
    ],
    "â": [
     466,
     466,
     30,
     -12,
     465,
     679
    ],
    "ã": [
     466,
     466,
     30,
     -12,
     465,
     642
    ],
    "ä": [
     466,
     466,
     30,
     -12,
     465,
     652
    ],
    "å": [
     466,
     466,
     30,
     -12,
     465,
     681
    ],
    "æ": [
     671,
     671,
     31,
     -12,
     656,
     454
    ],
    "ç": [
     422,
     422,
     30,
     -240,
     420,
     454
    ],
    "è": [
     437,
     437,
     30,
     -12,
     421,
     679.439005318302
    ],
    "é": [
     437,
     437,
     30,
     -12,
     421,
     679.9866080841889
    ],
    "ê": [
     437,
     437,
     30,
     -12,
     421,
     679
    ],
    "ë": [
     437,
     437,
     30,
     -12,
     421,
     652
    ],
    "ì": [
     295,
     295,
     24,
     0,
     283,
     679.439005318302
    ],
    "í": [
     295,
     295,
     29,
     0,
     283,
     679.9866080841889
    ],
    "î": [
     295,
     295,
     21,
     0,
     283,
     679
    ],
    "ï": [
     295,
     295,
     -26,
     0,
     315,
     652
    ],
    "ð": [
     522,
     522,
     29.96248240330946,
     -12,
     486,
     703
    ],
    "ñ": [
     566,
     566,
     26,
     0,
     549,
     642
    ],
    "ò": [
     525,
     525,
     30,
     -12,
     496,
     679.439005318302
    ],
    "ó": [
     525,
     525,
     30,
     -12,
     496,
     679.9866080841889
    ],
    "ô": [
     525,
     525,
     30,
     -12,
     496,
     679
    ],
    "õ": [
     525,
     525,
     30,
     -12,
     496,
     642
    ],
    "ö": [
     525,
     525,
     29,
     -12,
     496,
     652
    ],
    "÷": [
     577,
     577,
     47,
     38,
     531,
     470
    ],
    "ø": [
     531,
     531,
     30,
     -36,
     501,
     478
    ],
    "ù": [
     555,
     555,
     28,
     -12,
     542,
     678.4674362588286
    ],
    "ú": [
     555,
     555,
     28,
     -12,
     542,
     679.070213021178
    ],
    "û": [
     555,
     555,
     28,
     -12,
     542,
     679
    ],
    "ü": [
     555,
     555,
     28,
     -12,
     542,
     652
    ],
    "ý": [
     465,
     465,
     -7,
     -245,
     483,
     679.9866080841889
    ],
    "þ": [
     538,
     538,
     7,
     -230,
     509,
     703
    ],
    "ÿ": [
     465,
     465,
     -7,
     -245,
     483,
     652
    ],
    "Ā": [
     706,
     706,
     18,
     0,
     687,
     779
    ],
    "ā": [
     466,
     466,
     30,
     -12,
     465,
     614
    ],
    "Ă": [
     706,
     706,
     18,
     0,
     687,
     828
    ],
    "ă": [
     466,
     466,
     30,
     -12,
     465,
     660
    ],
    "Ą": [
     706,
     706,
     19,
     -233,
     687,
     665
    ],
    "ą": [
     467,
     467,
     30,
     -232,
     466,
     454
    ],
    "Ć": [
     676,
     676,
     42,
     -15,
     660,
     847
    ],
    "ć": [
     422,
     422,
     29,
     -12,
     418,
     679.9866080841889
    ],
    "Ĉ": [
     676,
     676,
     42,
     -15,
     660,
     845
    ],
    "ĉ": [
     422,
     422,
     29,
     -12,
     418,
     679
    ],
    "Ċ": [
     676,
     676,
     42,
     -15,
     660,
     844
    ],
    "ċ": [
     422,
     422,
     29,
     -12,
     418,
     657
    ],
    "Č": [
     676,
     676,
     42,
     -15,
     660,
     845
    ],
    "č": [
     422,
     422,
     29,
     -12,
     418,
     688
    ],
    "Ď": [
     761,
     761,
     32,
     0,
     717,
     830
    ],
    "ď": [
     547,
     547,
     29,
     -13,
     643,
     710
    ],
    "Đ": [
     760,
     760,
     38,
     0,
     718,
     650
    ],
    "đ": [
     548,
     548,
     29,
     -13,
     552,
     710
    ],
    "Ē": [
     581,
     581,
     26,
     0,
     571,
     780
    ],
    "ē": [
     437,
     437,
     30,
     -12,
     421,
     614
    ],
    "Ĕ": [
     581,
     581,
     26,
     0,
     571,
     830
    ],
    "ĕ": [
     437,
     437,
     30,
     -12,
     420,
     660
    ],
    "Ė": [
     581,
     581,
     26,
     0,
     571,
     842
    ],
    "ė": [
     437,
     437,
     30,
     -12,
     421,
     657
    ],
    "Ę": [
     580,
     580,
     26,
     -234,
     570,
     650
    ],
    "ę": [
     437,
     437,
     29,
     -230,
     420,
     454
    ],
    "Ě": [
     581,
     581,
     26,
     0,
     571,
     834
    ],
    "ě": [
     437,
     437,
     30,
     -12,
     421,
     688
    ],
    "Ĝ": [
     727,
     727,
     44,
     -15,
     703,
     841
    ],
    "ĝ": [
     492,
     492,
     27,
     -244,
     498,
     679
    ],
    "Ğ": [
     727,
     727,
     44,
     -15,
     703,
     839
    ],
    "ğ": [
     492,
     492,
     27,
     -244,
     498,
     660
    ],
    "Ġ": [
     727,
     727,
     44,
     -15,
     703,
     844
    ],
    "ġ": [
     492,
     492,
     27,
     -244,
     498,
     657
    ],
    "Ģ": [
     727,
     727,
     44,
     -262,
     703,
     665
    ],
    "ģ": [
     492,
     492,
     27,
     -244,
     498,
     717
    ],
    "Ĥ": [
     783,
     783,
     35,
     0,
     746,
     833
    ],
    "ĥ": [
     550,
     550,
     -17,
     0,
     531,
     863
    ],
    "Ħ": [
     783,
     783,
     35,
     0,
     746,
     650
    ],
    "ħ": [
     551,
     551,
     4,
     0,
     533,
     710
    ],
    "Ĩ": [
     378,
     378,
     37,
     0,
     338,
     805
    ],
    "ĩ": [
     295,
     295,
     2,
     0,
     293,
     642
    ],
    "Ī": [
     378,
     378,
     37,
     0,
     338,
     779
    ],
    "ī": [
     295,
     295,
     19,
     0,
     283,
     614
    ],
    "Ĭ": [
     378,
     378,
     37,
     0,
     338,
     828
    ],
    "ĭ": [
     295,
     295,
     23,
     0,
     284,
     660
    ],
    "Į": [
     378,
     378,
     37,
     -232,
     338,
     650
    ],
    "į": [
     296,
     296,
     27,
     -230,
     288,
     658
    ],
    "İ": [
     378,
     378,
     37,
     0,
     338,
     842
    ],
    "ı": [
     295,
     295,
     29,
     0,
     283,
     454
    ],
    "Ĳ": [
     744,
     744,
     37,
     -162,
     715,
     650
    ],
    "ĳ": [
     583,
     583,
     28,
     -244,
     510,
     657
    ],
    "Ĵ": [
     366,
     366,
     20,
     -162,
     338,
     833
    ],
    "ĵ": [
     291,
     291,
     -20,
     -248,
     274,
     679
    ],
    "Ķ": [
     703,
     703,
     37,
     -237,
     699,
     650
    ],
    "ķ": [
     513,
     513,
     9,
     -248,
     536,
     703
    ],
    "ĸ": [
     553,
     553,
     32,
     0,
     550,
     455
    ],
    "Ĺ": [
     551,
     551,
     24,
     0,
     548,
     833
    ],
    "ĺ": [
     278,
     278,
     10,
     0,
     279,
     869
    ],
    "Ļ": [
     551,
     551,
     24,
     -248,
     548,
     650
    ],
    "ļ": [
     278,
     278,
     10,
     -246,
     270,
     703
    ],
    "Ľ": [
     551,
     551,
     24,
     0,
     548,
     653
    ],
    "ľ": [
     278,
     278,
     10,
     0,
     364,
     711
    ],
    "Ŀ": [
     551,
     551,
     24,
     0,
     548,
     650
    ],
    "ŀ": [
     335,
     335,
     10,
     0,
     373,
     703
    ],
    "Ł": [
     563,
     563,
     33,
     0,
     560,
     650
    ],
    "ł": [
     302,
     302,
     16,
     0,
     299,
     709
    ],
    "Ń": [
     740,
     740,
     16,
     -10,
     724,
     833
    ],
    "ń": [
     566,
     566,
     26,
     0,
     549,
     679.9866080841889
    ],
    "Ņ": [
     740,
     740,
     16,
     -228,
     724,
     650
    ],
    "ņ": [
     566,
     566,
     26,
     -253,
     549,
     456
    ],
    "Ň": [
     740,
     740,
     16,
     -10,
     724,
     815
    ],
    "ň": [
     566,
     566,
     26,
     0,
     549,
     688
    ],
    "ŉ": [
     566,
     566,
     0,
     0,
     549,
     717
    ],
    "Ŋ": [
     740,
     740,
     16,
     -208,
     724,
     650
    ],
    "ŋ": [
     558,
     558,
     26,
     -207,
     490,
     456
    ],
    "Ō": [
     766,
     766,
     42,
     -15,
     725,
     780
    ],
    "ō": [
     525,
     525,
     30,
     -12,
     496,
     614
    ],
    "Ŏ": [
     766,
     766,
     42,
     -15,
     725,
     834
    ],
    "ŏ": [
     525,
     525,
     30,
     -12,
     495,
     660
    ],
    "Ő": [
     766,
     766,
     42,
     -15,
     725,
     826.9427400463467
    ],
    "ő": [
     525,
     525,
     30,
     -12,
     496,
     680.5958894465383
    ],
    "Œ": [
     992,
     992,
     41,
     -11,
     982,
     661
    ],
    "œ": [
     770,
     770,
     27,
     -12,
     752,
     454
    ],
    "Ŕ": [
     659,
     659,
     35,
     -9,
     660,
     833
    ],
    "ŕ": [
     404,
     404,
     28,
     0,
     402,
     679.070213021178
    ],
    "Ŗ": [
     659,
     659,
     35,
     -239,
     660,
     650
    ],
    "ŗ": [
     404,
     404,
     28,
     -253,
     402,
     455
    ],
    "Ř": [
     659,
     659,
     35,
     -9,
     660,
     830
    ],
    "ř": [
     404,
     404,
     28,
     0,
     402,
     689
    ],
    "Ś": [
     505,
     505,
     38,
     -15,
     472,
     842
    ],
    "ś": [
     383,
     383,
     40,
     -12,
     360,
     679.9866080841889
    ],
    "Ŝ": [
     505,
     505,
     38,
     -15,
     472,
     838
    ],
    "ŝ": [
     383,
     383,
     40,
     -12,
     360,
     679
    ],
    "Ş": [
     505,
     505,
     36,
     -236,
     473,
     665
    ],
    "ş": [
     387,
     387,
     37,
     -237,
     363,
     454.0693529093229
    ],
    "Š": [
     505,
     505,
     38,
     -15,
     472,
     843
    ],
    "š": [
     383,
     383,
     40,
     -12,
     360,
     688
    ],
    "Ţ": [
     641,
     641,
     27,
     -248,
     617,
     675
    ],
    "ţ": [
     339,
     339,
     16,
     -260,
     329,
     593
    ],
    "Ť": [
     641,
     641,
     27,
     0,
     616,
     830
    ],
    "ť": [
     339,
     339,
     16,
     -12,
     383,
     716
    ],
    "Ŧ": [
     637,
     637,
     28,
     0,
     612,
     675
    ],
    "ŧ": [
     336,
     336,
     14,
     -12,
     327,
     593
    ],
    "Ũ": [
     729,
     729,
     29,
     -15,
     723,
     805
    ],
    "ũ": [
     555,
     555,
     28,
     -12,
     542,
     642
    ],
    "Ū": [
     729,
     729,
     29,
     -15,
     723,
     780
    ],
    "ū": [
     555,
     555,
     28,
     -12,
     542,
     614
    ],
    "Ŭ": [
     729,
     729,
     29,
     -15,
     723,
     823
    ],
    "ŭ": [
     555,
     555,
     28,
     -12,
     542,
     659
    ],
    "Ů": [
     729,
     729,
     29,
     -15,
     723,
     854
    ],
    "ů": [
     555,
     555,
     28,
     -12,
     542,
     681
    ],
    "Ű": [
     729,
     729,
     29,
     -15,
     723,
     821.9427400463467
    ],
    "ű": [
     555,
     555,
     28,
     -12,
     542,
     679.6480733176375
    ],
    "Ų": [
     729,
     729,
     29,
     -232,
     724,
     650
    ],
    "ų": [
     555,
     555,
     25,
     -231,
     544,
     449
    ],
    "Ŵ": [
     979,
     979,
     13,
     -11,
     969,
     825
    ],
    "ŵ": [
     683,
     683,
     3,
     -11,
     699,
     679
    ],
    "Ŷ": [
     655,
     655,
     16,
     0,
     646,
     833
    ],
    "ŷ": [
     465,
     465,
     -7,
     -245,
     483,
     679
    ],
    "Ÿ": [
     655,
     655,
     16,
     0,
     646,
     828
    ],
    "Ź": [
     619,
     619,
     29,
     0,
     607,
     833
    ],
    "ź": [
     445,
     445,
     24,
     0,
     439,
     679.6480733176375
    ],
    "Ż": [
     619,
     619,
     29,
     0,
     607,
     843
    ],
    "ż": [
     445,
     445,
     24,
     0,
     439,
     657
    ],
    "Ž": [
     619,
     619,
     29,
     0,
     607,
     830
    ],
    "ž": [
     445,
     445,
     24,
     0,
     439,
     689
    ],
    "ſ": [
     296,
     296,
     23,
     0,
     407.74851773445585,
     703
    ],
    "–": [
     511,
     511,
     50,
     196,
     461,
     264
    ],
    "—": [
     921,
     921,
     50,
     196,
     871,
     263
    ],
    "‘": [
     242,
     242,
     29,
     432,
     203,
     717
    ],
    "’": [
     242,
     242,
     37,
     423,
     210,
     708
    ],
    "‚": [
     253,
     253,
     37,
     -147,
     221,
     156
    ],
    "“": [
     445,
     445,
     29,
     432,
     407,
     717
    ],
    "”": [
     445,
     445,
     35,
     423,
     414,
     708
    ],
    "„": [
     471,
     471,
     37,
     -147,
     438,
     156
    ],
    "†": [
     506,
     506,
     40,
     -98,
     455,
     637
    ],
    "‡": [
     492,
     492,
     40,
     -96,
     452,
     637
    ],
    "•": [
     399,
     399,
     65,
     83,
     334,
     361
    ],
    "…": [
     983,
     983,
     91,
     -12,
     895,
     140
    ],
    "‰": [
     1088,
     1088,
     41,
     -37,
     1054,
     651
    ],
    "‹": [
     279,
     279,
     45,
     32,
     235,
     416
    ],
    "›": [
     279,
     279,
     44,
     32,
     234,
     416
    ],
    "€": [
     500,
     500,
     11,
     -12,
     477,
     637
    ],
    "№": [
     897,
     897,
     25,
     -12,
     854,
     635
    ],
    "™": [
     482,
     482,
     24,
     477,
     458,
     643
    ]
   }
  },
  "Futura Bold": {
   "file": "bb-font-futura-bold.woff2",
   "sha256": "41c9dd1b859287e462d676a24bea6511a01926775b6940d962c7cf8f49617ca0",
   "full_name": "Futura BdCn BT Bold",
   "version": "mfgpctt-v1.52 Wednesday, January 13, 1993 4:09:13 pm (EST)",
   "units_per_em": 2048,
   "cap_height_units": 1460,
   "notdef": [
    1229,
    600,
    102,
    -362,
    1126,
    1444
   ],
   "glyph_fields": [
    "advance_units",
    "pdf_advance_milli_em",
    "x_min",
    "y_min",
    "x_max",
    "y_max"
   ],
   "glyphs": {
    " ": [
     451,
     220,
     null,
     null,
     null,
     null
    ],
    "!": [
     563,
     275,
     106,
     -18,
     459,
     1460
    ],
    "\"": [
     643,
     314,
     86,
     879,
     559,
     1436
    ],
    "#": [
     1575,
     769,
     70,
     -6,
     1505,
     1460
    ],
    "$": [
     901,
     440,
     37,
     -182,
     848,
     1620
    ],
    "%": [
     1677,
     819,
     74,
     -18,
     1589,
     1479
    ],
    "&": [
     1116,
     545,
     66,
     -10,
     1090,
     1432
    ],
    "'": [
     334,
     163,
     86,
     879,
     250,
     1436
    ],
    "(": [
     567,
     277,
     80,
     -444,
     532,
     1556
    ],
    ")": [
     567,
     277,
     33,
     -444,
     485,
     1556
    ],
    "*": [
     901,
     440,
     111,
     752,
     791,
     1460
    ],
    "+": [
     1706,
     833,
     254,
     0,
     1452,
     1221
    ],
    ",": [
     451,
     220,
     0,
     -281,
     451,
     326
    ],
    "-": [
     668,
     326,
     76,
     332,
     592,
     649
    ],
    ".": [
     451,
     220,
     49,
     -12,
     401,
     342
    ],
    "/": [
     627,
     306,
     0,
     -190,
     627,
     1479
    ],
    "0": [
     901,
     440,
     53,
     -18,
     848,
     1479
    ],
    "1": [
     901,
     440,
     197,
     0,
     616,
     1460
    ],
    "2": [
     901,
     440,
     63,
     0,
     821,
     1479
    ],
    "3": [
     901,
     440,
     47,
     -20,
     844,
     1479
    ],
    "4": [
     901,
     440,
     59,
     0,
     842,
     1460
    ],
    "5": [
     901,
     440,
     57,
     -18,
     819,
     1460
    ],
    "6": [
     901,
     440,
     53,
     -20,
     852,
     1460
    ],
    "7": [
     901,
     440,
     90,
     0,
     909,
     1460
    ],
    "8": [
     901,
     440,
     59,
     -18,
     842,
     1479
    ],
    "9": [
     901,
     440,
     49,
     0,
     844,
     1479
    ],
    ":": [
     563,
     275,
     106,
     -12,
     459,
     930
    ],
    ";": [
     563,
     275,
     -29,
     -281,
     459,
     930
    ],
    "<": [
     1706,
     833,
     264,
     47,
     1442,
     1176
    ],
    "=": [
     1706,
     833,
     254,
     322,
     1452,
     901
    ],
    ">": [
     1706,
     833,
     264,
     47,
     1442,
     1176
    ],
    "?": [
     883,
     431,
     45,
     -18,
     803,
     1479
    ],
    "@": [
     2048,
     1000,
     98,
     -301,
     1950,
     1473
    ],
    "A": [
     952,
     465,
     -8,
     0,
     961,
     1460
    ],
    "B": [
     999,
     488,
     115,
     0,
     944,
     1460
    ],
    "C": [
     932,
     455,
     68,
     -18,
     866,
     1479
    ],
    "D": [
     1102,
     538,
     115,
     0,
     1036,
     1460
    ],
    "E": [
     811,
     396,
     115,
     0,
     729,
     1460
    ],
    "F": [
     799,
     390,
     115,
     0,
     745,
     1460
    ],
    "G": [
     1139,
     556,
     66,
     -18,
     1073,
     1479
    ],
    "H": [
     1133,
     553,
     115,
     0,
     1020,
     1460
    ],
    "I": [
     553,
     270,
     127,
     0,
     424,
     1460
    ],
    "J": [
     645,
     315,
     6,
     -20,
     539,
     1460
    ],
    "K": [
     975,
     476,
     115,
     2,
     995,
     1460
    ],
    "L": [
     735,
     359,
     115,
     0,
     735,
     1460
    ],
    "M": [
     1366,
     667,
     43,
     0,
     1323,
     1460
    ],
    "N": [
     1135,
     554,
     115,
     0,
     1020,
     1460
    ],
    "O": [
     1157,
     565,
     66,
     -18,
     1092,
     1479
    ],
    "P": [
     932,
     455,
     115,
     0,
     893,
     1460
    ],
    "Q": [
     1157,
     565,
     66,
     -106,
     1104,
     1479
    ],
    "R": [
     940,
     459,
     115,
     0,
     942,
     1460
    ],
    "S": [
     786,
     384,
     47,
     -18,
     741,
     1479
    ],
    "T": [
     797,
     389,
     29,
     0,
     768,
     1460
    ],
    "U": [
     1124,
     549,
     106,
     -18,
     1018,
     1460
    ],
    "V": [
     995,
     486,
     -39,
     0,
     1034,
     1460
    ],
    "W": [
     1497,
     731,
     2,
     0,
     1497,
     1460
    ],
    "X": [
     864,
     422,
     -53,
     0,
     918,
     1460
    ],
    "Y": [
     801,
     391,
     -84,
     0,
     883,
     1460
    ],
    "Z": [
     877,
     428,
     -16,
     0,
     848,
     1460
    ],
    "[": [
     567,
     277,
     66,
     -397,
     530,
     1507
    ],
    "\\": [
     627,
     306,
     0,
     -190,
     627,
     1479
    ],
    "]": [
     567,
     277,
     35,
     -397,
     500,
     1507
    ],
    "^": [
     2048,
     1000,
     418,
     899,
     1628,
     1460
    ],
    "_": [
     1024,
     500,
     0,
     -483,
     1024,
     -311
    ],
    "`": [
     1024,
     500,
     229,
     1114,
     662,
     1485
    ],
    "a": [
     928,
     453,
     61,
     -18,
     825,
     991
    ],
    "b": [
     928,
     453,
     102,
     -20,
     864,
     1550
    ],
    "c": [
     651,
     318,
     53,
     -18,
     614,
     999
    ],
    "d": [
     928,
     453,
     61,
     -20,
     825,
     1550
    ],
    "e": [
     877,
     428,
     47,
     -18,
     838,
     999
    ],
    "f": [
     530,
     259,
     25,
     0,
     512,
     1569
    ],
    "g": [
     928,
     453,
     61,
     -453,
     825,
     991
    ],
    "h": [
     915,
     447,
     96,
     0,
     823,
     1550
    ],
    "i": [
     483,
     236,
     86,
     0,
     397,
     1401
    ],
    "j": [
     483,
     236,
     86,
     -395,
     397,
     1401
    ],
    "k": [
     858,
     419,
     100,
     0,
     891,
     1550
    ],
    "l": [
     483,
     236,
     106,
     0,
     377,
     1550
    ],
    "m": [
     1343,
     656,
     98,
     0,
     1251,
     991
    ],
    "n": [
     915,
     447,
     96,
     0,
     823,
     991
    ],
    "o": [
     909,
     444,
     47,
     -18,
     864,
     999
    ],
    "p": [
     928,
     453,
     102,
     -395,
     864,
     991
    ],
    "q": [
     928,
     453,
     61,
     -395,
     825,
     991
    ],
    "r": [
     588,
     287,
     100,
     0,
     573,
     999
    ],
    "s": [
     686,
     335,
     27,
     -18,
     637,
     999
    ],
    "t": [
     526,
     257,
     20,
     0,
     504,
     1264
    ],
    "u": [
     903,
     441,
     92,
     -18,
     811,
     981
    ],
    "v": [
     772,
     377,
     2,
     0,
     770,
     981
    ],
    "w": [
     1186,
     579,
     -4,
     0,
     1190,
     981
    ],
    "x": [
     758,
     370,
     -12,
     0,
     770,
     981
    ],
    "y": [
     758,
     370,
     2,
     -395,
     768,
     981
    ],
    "z": [
     674,
     329,
     18,
     0,
     651,
     981
    ],
    "{": [
     1024,
     500,
     162,
     -414,
     874,
     1477
    ],
    "|": [
     1024,
     500,
     424,
     -483,
     602,
     1565
    ],
    "}": [
     1024,
     500,
     152,
     -414,
     862,
     1477
    ],
    "~": [
     1706,
     833,
     178,
     434,
     1530,
     784
    ]
   }
  },
  "Verdana": {
   "file": "bb-font-verdana.woff2",
   "sha256": "d9c8ff474c9a40e244af0b31ea558c4b8f736c019b28b74e757880d6155d5293",
   "full_name": "Verdana Bold",
   "version": "Version 5.01",
   "units_per_em": 2048,
   "cap_height_units": 1489,
   "notdef": [
    2048,
    1000,
    256,
    0,
    1792,
    1536
   ],
   "glyph_fields": [
    "advance_units",
    "pdf_advance_milli_em",
    "x_min",
    "y_min",
    "x_max",
    "y_max"
   ],
   "glyphs": {
    " ": [
     700,
     342,
     null,
     null,
     null,
     null
    ],
    "!": [
     824,
     402,
     203,
     0,
     621,
     1489
    ],
    "\"": [
     1203,
     587,
     167,
     967,
     1036,
     1556
    ],
    "#": [
     1776,
     867,
     149,
     0,
     1624,
     1489
    ],
    "$": [
     1456,
     711,
     134,
     -361,
     1340,
     1576
    ],
    "%": [
     2605,
     1272,
     143,
     -31,
     2462,
     1518
    ],
    "&": [
     1766,
     862,
     121,
     -31,
     1802,
     1520
    ],
    "'": [
     680,
     332,
     167,
     967,
     513,
     1556
    ],
    "(": [
     1113,
     543,
     193,
     -412,
     947,
     1556
    ],
    ")": [
     1113,
     543,
     166,
     -412,
     920,
     1556
    ],
    "*": [
     1456,
     711,
     204,
     534,
     1252,
     1556
    ],
    "+": [
     1776,
     867,
     218,
     0,
     1558,
     1324
    ],
    ",": [
     740,
     361,
     35,
     -370,
     618,
     393
    ],
    "-": [
     983,
     480,
     110,
     518,
     873,
     806
    ],
    ".": [
     740,
     361,
     183,
     0,
     557,
     393
    ],
    "/": [
     1412,
     689,
     123,
     -324,
     1223,
     1556
    ],
    "0": [
     1456,
     711,
     112,
     -31,
     1344,
     1519
    ],
    "1": [
     1456,
     711,
     266,
     0,
     1260,
     1493
    ],
    "2": [
     1456,
     711,
     185,
     0,
     1354,
     1518
    ],
    "3": [
     1456,
     711,
     140,
     -31,
     1315,
     1520
    ],
    "4": [
     1456,
     711,
     84,
     -4,
     1375,
     1489
    ],
    "5": [
     1456,
     711,
     164,
     -31,
     1322,
     1489
    ],
    "6": [
     1456,
     711,
     134,
     -31,
     1352,
     1517
    ],
    "7": [
     1456,
     711,
     156,
     0,
     1323,
     1489
    ],
    "8": [
     1456,
     711,
     99,
     -34,
     1357,
     1523
    ],
    "9": [
     1456,
     711,
     104,
     -29,
     1322,
     1519
    ],
    ":": [
     824,
     402,
     225,
     0,
     599,
     1123
    ],
    ";": [
     824,
     402,
     77,
     -370,
     660,
     1123
    ],
    "<": [
     1776,
     867,
     204,
     -7,
     1540,
     1331
    ],
    "=": [
     1776,
     867,
     249,
     265,
     1527,
     1059
    ],
    ">": [
     1776,
     867,
     236,
     -7,
     1572,
     1331
    ],
    "?": [
     1263,
     617,
     147,
     0,
     1151,
     1519
    ],
    "@": [
     1974,
     964,
     145,
     -229,
     1828,
     1518
    ],
    "A": [
     1590,
     776,
     24,
     0,
     1566,
     1489
    ],
    "B": [
     1560,
     762,
     190,
     0,
     1464,
     1489
    ],
    "C": [
     1482,
     724,
     103,
     -29,
     1390,
     1518
    ],
    "D": [
     1700,
     830,
     190,
     0,
     1597,
     1489
    ],
    "E": [
     1399,
     683,
     190,
     0,
     1267,
     1489
    ],
    "F": [
     1332,
     650,
     190,
     0,
     1257,
     1489
    ],
    "G": [
     1661,
     811,
     103,
     -31,
     1507,
     1518
    ],
    "H": [
     1715,
     837,
     190,
     0,
     1525,
     1489
    ],
    "I": [
     1118,
     546,
     123,
     0,
     995,
     1489
    ],
    "J": [
     1137,
     555,
     42,
     -23,
     966,
     1489
    ],
    "K": [
     1579,
     771,
     190,
     0,
     1580,
     1489
    ],
    "L": [
     1305,
     637,
     190,
     0,
     1264,
     1489
    ],
    "M": [
     1941,
     948,
     190,
     0,
     1751,
     1489
    ],
    "N": [
     1734,
     847,
     190,
     0,
     1544,
     1489
    ],
    "O": [
     1741,
     850,
     103,
     -31,
     1638,
     1520
    ],
    "P": [
     1501,
     733,
     190,
     0,
     1419,
     1489
    ],
    "Q": [
     1741,
     850,
     103,
     -425,
     1638,
     1520
    ],
    "R": [
     1602,
     782,
     190,
     0,
     1624,
     1489
    ],
    "S": [
     1455,
     710,
     109,
     -27,
     1382,
     1516
    ],
    "T": [
     1396,
     682,
     41,
     0,
     1355,
     1489
    ],
    "U": [
     1663,
     812,
     169,
     -31,
     1494,
     1489
    ],
    "V": [
     1564,
     764,
     24,
     0,
     1540,
     1489
    ],
    "W": [
     2311,
     1128,
     66,
     0,
     2245,
     1489
    ],
    "X": [
     1564,
     764,
     24,
     0,
     1540,
     1489
    ],
    "Y": [
     1509,
     737,
     9,
     0,
     1500,
     1489
    ],
    "Z": [
     1417,
     692,
     90,
     0,
     1341,
     1489
    ],
    "[": [
     1113,
     543,
     248,
     -392,
     916,
     1556
    ],
    "\\": [
     1412,
     689,
     189,
     -324,
     1289,
     1556
    ],
    "]": [
     1113,
     543,
     198,
     -392,
     866,
     1556
    ],
    "^": [
     1776,
     867,
     197,
     640,
     1580,
     1489
    ],
    "_": [
     1456,
     711,
     -16,
     -350,
     1472,
     -139
    ],
    "`": [
     1456,
     711,
     374,
     1283,
     972,
     1676
    ],
    "a": [
     1368,
     668,
     86,
     -30,
     1207,
     1155
    ],
    "b": [
     1432,
     699,
     170,
     -22,
     1342,
     1556
    ],
    "c": [
     1205,
     588,
     88,
     -30,
     1137,
     1154
    ],
    "d": [
     1432,
     699,
     90,
     -31,
     1262,
     1556
    ],
    "e": [
     1360,
     664,
     88,
     -30,
     1276,
     1158
    ],
    "f": [
     865,
     422,
     43,
     0,
     898,
     1566
    ],
    "g": [
     1432,
     699,
     90,
     -423,
     1262,
     1154
    ],
    "h": [
     1459,
     712,
     170,
     0,
     1298,
     1556
    ],
    "i": [
     700,
     342,
     160,
     0,
     540,
     1556
    ],
    "j": [
     825,
     403,
     -58,
     -423,
     656,
     1556
    ],
    "k": [
     1374,
     671,
     170,
     0,
     1362,
     1556
    ],
    "l": [
     700,
     342,
     170,
     0,
     530,
     1556
    ],
    "m": [
     2167,
     1058,
     170,
     0,
     2006,
     1154
    ],
    "n": [
     1459,
     712,
     170,
     0,
     1298,
     1154
    ],
    "o": [
     1406,
     687,
     88,
     -35,
     1318,
     1158
    ],
    "p": [
     1432,
     699,
     170,
     -412,
     1342,
     1154
    ],
    "q": [
     1432,
     699,
     90,
     -412,
     1262,
     1154
    ],
    "r": [
     1018,
     497,
     170,
     0,
     984,
     1127
    ],
    "s": [
     1215,
     593,
     95,
     -31,
     1146,
     1154
    ],
    "t": [
     933,
     456,
     43,
     -22,
     888,
     1444
    ],
    "u": [
     1459,
     712,
     161,
     -31,
     1289,
     1123
    ],
    "v": [
     1331,
     650,
     30,
     0,
     1301,
     1123
    ],
    "w": [
     2006,
     979,
     45,
     0,
     1961,
     1123
    ],
    "x": [
     1370,
     669,
     26,
     0,
     1344,
     1123
    ],
    "y": [
     1333,
     651,
     30,
     -412,
     1303,
     1123
    ],
    "z": [
     1222,
     597,
     84,
     0,
     1139,
     1123
    ],
    "{": [
     1456,
     711,
     152,
     -392,
     1255,
     1556
    ],
    "|": [
     1113,
     543,
     411,
     -392,
     702,
     1556
    ],
    "}": [
     1456,
     711,
     201,
     -392,
     1304,
     1556
    ],
    "~": [
     1776,
     867,
     157,
     325,
     1623,
     1007
    ]
   }
  },
  "Rockwell": {
   "file": "bb-font-rockwell.woff2",
   "sha256": "22d4a7f856e92985840cabc6bd08f5ffe2073e9edb0495c5a62e0e1aa4099406",
   "full_name": "Rockwell",
   "version": "Version 1.65",
   "units_per_em": 2048,
   "cap_height_units": 1391,
   "notdef": [
    1536,
    750,
    256,
    0,
    1280,
    1280
   ],
   "glyph_fields": [
    "advance_units",
    "pdf_advance_milli_em",
    "x_min",
    "y_min",
    "x_max",
    "y_max"
   ],
   "glyphs": {
    " ": [
     512,
     250,
     null,
     null,
     null,
     null
    ],
    "!": [
     598,
     292,
     176,
     0,
     422,
     1391
    ],
    "\"": [
     831,
     406,
     132,
     829,
     699,
     1413
    ],
    "#": [
     1366,
     667,
     85,
     -19,
     1280,
     1410
    ],
    "$": [
     1110,
     542,
     63,
     -175,
     1024,
     1444
    ],
    "%": [
     1985,
     969,
     164,
     -22,
     1819,
     1413
    ],
    "&": [
     1386,
     677,
     63,
     -22,
     1340,
     1413
    ],
    "'": [
     362,
     177,
     81,
     828,
     282,
     1413
    ],
    "(": [
     768,
     375,
     166,
     -445,
     711,
     1416
    ],
    ")": [
     768,
     375,
     57,
     -445,
     602,
     1416
    ],
    "*": [
     1067,
     521,
     67,
     533,
     997,
     1413
    ],
    "+": [
     1366,
     667,
     135,
     148,
     1231,
     1243
    ],
    ",": [
     598,
     292,
     176,
     -277,
     422,
     246
    ],
    "-": [
     725,
     354,
     63,
     385,
     663,
     575
    ],
    ".": [
     598,
     292,
     176,
     0,
     422,
     246
    ],
    "/": [
     897,
     438,
     10,
     -22,
     886,
     1419
    ],
    "0": [
     1110,
     542,
     72,
     -22,
     1037,
     1413
    ],
    "1": [
     1110,
     542,
     295,
     0,
     856,
     1389
    ],
    "2": [
     1110,
     542,
     82,
     0,
     984,
     1413
    ],
    "3": [
     1110,
     542,
     68,
     -22,
     1025,
     1413
    ],
    "4": [
     1110,
     542,
     60,
     0,
     1022,
     1402
    ],
    "5": [
     1110,
     542,
     73,
     -22,
     1019,
     1389
    ],
    "6": [
     1110,
     542,
     100,
     -22,
     996,
     1413
    ],
    "7": [
     1110,
     542,
     121,
     0,
     990,
     1389
    ],
    "8": [
     1110,
     542,
     68,
     -22,
     1040,
     1413
    ],
    "9": [
     1110,
     542,
     94,
     -22,
     990,
     1413
    ],
    ":": [
     598,
     292,
     176,
     0,
     422,
     968
    ],
    ";": [
     598,
     292,
     176,
     -277,
     422,
     968
    ],
    "<": [
     1366,
     667,
     135,
     165,
     1231,
     1226
    ],
    "=": [
     1366,
     667,
     135,
     382,
     1231,
     1009
    ],
    ">": [
     1366,
     667,
     135,
     165,
     1231,
     1226
    ],
    "?": [
     961,
     469,
     62,
     0,
     897,
     1413
    ],
    "@": [
     2068,
     1010,
     114,
     -456,
     2008,
     1467
    ],
    "A": [
     1430,
     698,
     -16,
     0,
     1446,
     1391
    ],
    "B": [
     1194,
     583,
     46,
     0,
     1107,
     1391
    ],
    "C": [
     1556,
     760,
     87,
     -22,
     1458,
     1413
    ],
    "D": [
     1493,
     729,
     26,
     0,
     1389,
     1391
    ],
    "E": [
     1280,
     625,
     56,
     0,
     1212,
     1391
    ],
    "F": [
     1130,
     552,
     37,
     0,
     1116,
     1391
    ],
    "G": [
     1642,
     802,
     99,
     -22,
     1545,
     1413
    ],
    "H": [
     1450,
     708,
     55,
     0,
     1397,
     1391
    ],
    "I": [
     641,
     313,
     64,
     0,
     576,
     1391
    ],
    "J": [
     641,
     313,
     -72,
     -436,
     615,
     1391
    ],
    "K": [
     1280,
     625,
     37,
     0,
     1273,
     1391
    ],
    "L": [
     1067,
     521,
     29,
     0,
     1049,
     1391
    ],
    "M": [
     1792,
     875,
     50,
     -14,
     1743,
     1391
    ],
    "N": [
     1473,
     719,
     10,
     -14,
     1469,
     1391
    ],
    "O": [
     1642,
     802,
     102,
     -22,
     1541,
     1413
    ],
    "P": [
     1174,
     573,
     41,
     0,
     1122,
     1391
    ],
    "Q": [
     1642,
     802,
     102,
     -268,
     1540,
     1413
    ],
    "R": [
     1237,
     604,
     26,
     0,
     1241,
     1391
    ],
    "S": [
     1087,
     531,
     66,
     -22,
     1023,
     1413
    ],
    "T": [
     1174,
     573,
     24,
     0,
     1151,
     1391
    ],
    "U": [
     1386,
     677,
     27,
     -22,
     1360,
     1391
    ],
    "V": [
     1450,
     708,
     -4,
     -14,
     1455,
     1391
    ],
    "W": [
     2048,
     1000,
     0,
     -14,
     2049,
     1391
    ],
    "X": [
     1343,
     656,
     21,
     0,
     1325,
     1391
    ],
    "Y": [
     1323,
     646,
     -21,
     0,
     1343,
     1391
    ],
    "Z": [
     1153,
     563,
     51,
     0,
     1085,
     1391
    ],
    "[": [
     768,
     375,
     215,
     -417,
     709,
     1391
    ],
    "\\": [
     897,
     438,
     10,
     -22,
     886,
     1419
    ],
    "]": [
     768,
     375,
     59,
     -417,
     553,
     1391
    ],
    "^": [
     961,
     469,
     54,
     590,
     907,
     1391
    ],
    "_": [
     1024,
     500,
     -12,
     -256,
     1036,
     -154
    ],
    "`": [
     682,
     333,
     111,
     1096,
     528,
     1413
    ],
    "a": [
     1087,
     531,
     94,
     -16,
     1061,
     995
    ],
    "b": [
     1323,
     646,
     54,
     -16,
     1234,
     1391
    ],
    "c": [
     1067,
     521,
     72,
     -28,
     1021,
     995
    ],
    "d": [
     1280,
     625,
     90,
     -16,
     1275,
     1391
    ],
    "e": [
     1174,
     573,
     74,
     -28,
     1098,
     995
    ],
    "f": [
     598,
     292,
     56,
     0,
     704,
     1419
    ],
    "g": [
     1280,
     625,
     72,
     -456,
     1257,
     983
    ],
    "h": [
     1174,
     573,
     42,
     0,
     1162,
     1391
    ],
    "i": [
     598,
     292,
     66,
     0,
     556,
     1411
    ],
    "j": [
     598,
     292,
     -38,
     -426,
     432,
     1411
    ],
    "k": [
     1174,
     573,
     50,
     0,
     1150,
     1391
    ],
    "l": [
     598,
     292,
     41,
     0,
     551,
     1391
    ],
    "m": [
     1772,
     865,
     54,
     0,
     1761,
     983
    ],
    "n": [
     1174,
     573,
     55,
     0,
     1167,
     983
    ],
    "o": [
     1174,
     573,
     78,
     -28,
     1096,
     995
    ],
    "p": [
     1280,
     625,
     14,
     -434,
     1196,
     983
    ],
    "q": [
     1260,
     615,
     74,
     -434,
     1256,
     983
    ],
    "r": [
     854,
     417,
     45,
     0,
     825,
     983
    ],
    "s": [
     938,
     458,
     84,
     -16,
     879,
     983
    ],
    "t": [
     618,
     302,
     62,
     -16,
     557,
     1291
    ],
    "u": [
     1153,
     563,
     53,
     -16,
     1133,
     968
    ],
    "v": [
     1110,
     542,
     -4,
     -16,
     1113,
     968
    ],
    "w": [
     1579,
     771,
     -3,
     -16,
     1579,
     968
    ],
    "x": [
     1130,
     552,
     36,
     0,
     1095,
     968
    ],
    "y": [
     1153,
     563,
     17,
     -434,
     1135,
     968
    ],
    "z": [
     918,
     448,
     33,
     0,
     866,
     968
    ],
    "{": [
     682,
     333,
     58,
     -434,
     637,
     1391
    ],
    "|": [
     1079,
     527,
     461,
     -456,
     618,
     1419
    ],
    "}": [
     682,
     333,
     45,
     -434,
     624,
     1391
    ],
    "~": [
     1194,
     583,
     49,
     538,
     1145,
     853
    ]
   }
  },
  "Arial": {
   "file": "arial.ttf",
   "sha256": "b3658eadae55e682b5f69eb64c439c1ecc8f196c0bb8d4756d145d13bc86476a",
   "full_name": "Arial",
   "version": "Version 7.06",
   "units_per_em": 2048,
   "cap_height_units": 1466,
   "notdef": [
    1536,
    750,
    256,
    0,
    1280,
    1280
   ],
   "glyph_fields": [
    "advance_units",
    "pdf_advance_milli_em",
    "x_min",
    "y_min",
    "x_max",
    "y_max"
   ],
   "glyphs": {
    " ": [
     569,
     278,
     null,
     null,
     null,
     null
    ],
    "!": [
     569,
     278,
     176,
     0,
     399,
     1466
    ],
    "\"": [
     727,
     355,
     94,
     947,
     631,
     1466
    ],
    "#": [
     1139,
     556,
     21,
     -25,
     1113,
     1491
    ],
    "$": [
     1139,
     556,
     73,
     -211,
     1043,
     1601
    ],
    "%": [
     1821,
     889,
     119,
     -54,
     1695,
     1491
    ],
    "&": [
     1366,
     667,
     88,
     -34,
     1319,
     1491
    ],
    "'": [
     391,
     191,
     90,
     947,
     295,
     1466
    ],
    "(": [
     682,
     333,
     124,
     -431,
     608,
     1491
    ],
    ")": [
     682,
     333,
     124,
     -431,
     608,
     1491
    ],
    "*": [
     797,
     389,
     64,
     867,
     725,
     1491
    ],
    "+": [
     1196,
     584,
     114,
     237,
     1082,
     1206
    ],
    ",": [
     569,
     278,
     170,
     -290,
     387,
     205
    ],
    "-": [
     682,
     333,
     65,
     440,
     618,
     621
    ],
    ".": [
     569,
     278,
     186,
     0,
     391,
     205
    ],
    "/": [
     569,
     278,
     0,
     -25,
     569,
     1491
    ],
    "0": [
     1139,
     556,
     85,
     -25,
     1041,
     1472
    ],
    "1": [
     1139,
     556,
     223,
     0,
     763,
     1472
    ],
    "2": [
     1139,
     556,
     61.84,
     0,
     1031,
     1472
    ],
    "3": [
     1139,
     556,
     86,
     -26,
     1046,
     1472
    ],
    "4": [
     1139,
     556,
     26,
     0,
     1040,
     1466
    ],
    "5": [
     1139,
     556,
     85,
     -25,
     1057,
     1446
    ],
    "6": [
     1139,
     556,
     77,
     -25,
     1045,
     1472
    ],
    "7": [
     1139,
     556,
     97,
     0,
     1046,
     1447
    ],
    "8": [
     1139,
     556,
     83,
     -25,
     1049,
     1472
    ],
    "9": [
     1139,
     556,
     85,
     -25,
     1049,
     1472
    ],
    ":": [
     569,
     278,
     185,
     0,
     390,
     1062
    ],
    ";": [
     569,
     278,
     170,
     -290,
     387,
     1062
    ],
    "<": [
     1196,
     584,
     112,
     226,
     1083,
     1219
    ],
    "=": [
     1196,
     584,
     114,
     417,
     1082,
     1030
    ],
    ">": [
     1196,
     584,
     112,
     226,
     1083,
     1219
    ],
    "?": [
     1139,
     556,
     90,
     0,
     1036,
     1491
    ],
    "@": [
     2079,
     1015,
     111,
     -431,
     2005,
     1493
    ],
    "A": [
     1366,
     667,
     -3,
     0,
     1369,
     1466
    ],
    "B": [
     1366,
     667,
     150,
     0,
     1257,
     1466
    ],
    "C": [
     1479,
     722,
     102,
     -25,
     1398,
     1491
    ],
    "D": [
     1479,
     722,
     158,
     0,
     1370,
     1466
    ],
    "E": [
     1366,
     667,
     162,
     0,
     1256,
     1466
    ],
    "F": [
     1251,
     611,
     168,
     0,
     1157,
     1466
    ],
    "G": [
     1593,
     778,
     109,
     -25,
     1465,
     1491
    ],
    "H": [
     1479,
     722,
     164,
     0,
     1314,
     1466
    ],
    "I": [
     569,
     278,
     191,
     0,
     385,
     1466
    ],
    "J": [
     1024,
     500,
     58.84976525821597,
     -25,
     865,
     1466
    ],
    "K": [
     1366,
     667,
     150,
     0,
     1362,
     1466
    ],
    "L": [
     1139,
     556,
     150,
     0,
     1066,
     1466
    ],
    "M": [
     1706,
     833,
     152,
     0,
     1551,
     1466
    ],
    "N": [
     1479,
     722,
     156,
     0,
     1311,
     1466
    ],
    "O": [
     1593,
     778,
     99,
     -25,
     1501,
     1492
    ],
    "P": [
     1366,
     667,
     158,
     0,
     1277,
     1466
    ],
    "Q": [
     1593,
     778,
     88,
     -114,
     1518,
     1492
    ],
    "R": [
     1479,
     722,
     161,
     0,
     1453,
     1466
    ],
    "S": [
     1366,
     667,
     92,
     -25,
     1259,
     1491
    ],
    "T": [
     1251,
     611,
     48,
     0,
     1210,
     1466
    ],
    "U": [
     1479,
     722,
     161,
     -25,
     1314,
     1466
    ],
    "V": [
     1366,
     667,
     9,
     0,
     1350,
     1466
    ],
    "W": [
     1933,
     944,
     25,
     0,
     1910,
     1466
    ],
    "X": [
     1366,
     667,
     9,
     0,
     1353,
     1466
    ],
    "Y": [
     1366,
     667,
     6,
     0,
     1350,
     1466
    ],
    "Z": [
     1251,
     611,
     41,
     0,
     1200,
     1466
    ],
    "[": [
     569,
     278,
     139,
     -407,
     536,
     1466
    ],
    "\\": [
     569,
     278,
     0,
     -25,
     569,
     1491
    ],
    "]": [
     569,
     278,
     39,
     -407,
     436,
     1466
    ],
    "^": [
     961,
     469,
     54,
     690,
     907,
     1491
    ],
    "_": [
     1139,
     556,
     -31,
     -407,
     1162,
     -277
    ],
    "`": [
     682,
     333,
     89,
     1194,
     465,
     1474
    ],
    "a": [
     1139,
     556,
     74,
     -24,
     1052,
     1086
    ],
    "b": [
     1139,
     556,
     134,
     -24,
     1055,
     1466
    ],
    "c": [
     1024,
     500,
     80,
     -24,
     1005,
     1086
    ],
    "d": [
     1139,
     556,
     70,
     -24,
     991,
     1466
    ],
    "e": [
     1139,
     556,
     75,
     -24,
     1054,
     1086
    ],
    "f": [
     569,
     278,
     19,
     0,
     640,
     1491
    ],
    "g": [
     1139,
     556,
     66,
     -431,
     1002,
     1086
    ],
    "h": [
     1139,
     556,
     135,
     0,
     1000,
     1466
    ],
    "i": [
     455,
     222,
     136,
     0,
     316,
     1466
    ],
    "j": [
     455,
     222,
     -94,
     -431,
     314,
     1466
    ],
    "k": [
     1024,
     500,
     136,
     0,
     1016,
     1466
    ],
    "l": [
     455,
     222,
     131,
     0,
     311,
     1466
    ],
    "m": [
     1706,
     833,
     135,
     0,
     1574,
     1086
    ],
    "n": [
     1139,
     556,
     135,
     0,
     998,
     1086
    ],
    "o": [
     1139,
     556,
     68,
     -24,
     1063,
     1086
    ],
    "p": [
     1139,
     556,
     135,
     -407,
     1057,
     1086
    ],
    "q": [
     1139,
     556,
     72,
     -407,
     992,
     1086
    ],
    "r": [
     682,
     333,
     133,
     0,
     710,
     1086
    ],
    "s": [
     1024,
     500,
     63,
     -24,
     945,
     1086
    ],
    "t": [
     569,
     278,
     36,
     -14,
     554,
     1433
    ],
    "u": [
     1139,
     556,
     131,
     -24,
     992,
     1062
    ],
    "v": [
     1024,
     500,
     26,
     0,
     1000,
     1062
    ],
    "w": [
     1479,
     722,
     6,
     0,
     1463,
     1062
    ],
    "x": [
     1024,
     500,
     15,
     0,
     1009,
     1062
    ],
    "y": [
     1024,
     500,
     33,
     -431,
     1006,
     1062
    ],
    "z": [
     1024,
     500,
     40,
     0,
     980,
     1062
    ],
    "{": [
     684,
     334,
     57,
     -431,
     636,
     1491
    ],
    "|": [
     532,
     260,
     188,
     -431,
     345,
     1491
    ],
    "}": [
     684,
     334,
     47,
     -431,
     626,
     1491
    ],
    "~": [
     1196,
     584,
     87,
     557,
     1110,
     885
    ],
    " ": [
     569,
     278,
     null,
     null,
     null,
     null
    ],
    "¡": [
     682,
     333,
     232,
     -404,
     455,
     1062
    ],
    "¢": [
     1139,
     556,
     107,
     -409,
     1034,
     1466
    ],
    "£": [
     1139,
     556,
     27,
     -28,
     1082,
     1491
    ],
    "¤": [
     1139,
     556,
     74,
     235,
     1057,
     1216
    ],
    "¥": [
     1139,
     556,
     -3,
     0,
     1133,
     1466
    ],
    "¦": [
     532,
     260,
     188,
     -431,
     345,
     1491
    ],
    "§": [
     1139,
     556,
     81,
     -431,
     1045,
     1491
    ],
    "¨": [
     682,
     333,
     61,
     1270,
     622,
     1475
    ],
    "©": [
     1509,
     737,
     3,
     -18,
     1512,
     1491
    ],
    "ª": [
     758,
     370,
     47,
     746,
     718,
     1491
    ],
    "«": [
     1139,
     556,
     134,
     72,
     991,
     984
    ],
    "¬": [
     1196,
     584,
     114,
     424,
     1082,
     1030
    ],
    "­": [
     682,
     333,
     65,
     440,
     618,
     621
    ],
    "®": [
     1509,
     737,
     3,
     -18,
     1512,
     1491
    ],
    "¯": [
     1131,
     552,
     -31,
     1566,
     1162,
     1695
    ],
    "°": [
     819,
     400,
     128,
     936,
     683,
     1491
    ],
    "±": [
     1124,
     549,
     78,
     0,
     1046,
     1229
    ],
    "²": [
     682,
     333,
     25,
     733,
     648,
     1484
    ],
    "³": [
     682,
     333,
     33,
     715,
     646,
     1484
    ],
    "´": [
     682,
     333,
     222,
     1194,
     591,
     1474
    ],
    "µ": [
     1180,
     576,
     160,
     -407,
     1018,
     1062
    ],
    "¶": [
     1100,
     537,
     1,
     -407,
     1107,
     1466
    ],
    "·": [
     682,
     333,
     238,
     637,
     443,
     842
    ],
    "¸": [
     682,
     333,
     107,
     -421,
     540,
     23
    ],
    "¹": [
     682,
     333,
     107,
     733,
     476,
     1484
    ],
    "º": [
     748,
     365,
     45,
     740,
     701,
     1491
    ],
    "»": [
     1139,
     556,
     140,
     72,
     997,
     984
    ],
    "¼": [
     1708,
     834,
     107,
     -57,
     1678,
     1491
    ],
    "½": [
     1708,
     834,
     107,
     -57,
     1672,
     1491
    ],
    "¾": [
     1708,
     834,
     33,
     -57,
     1678,
     1491
    ],
    "¿": [
     1251,
     611,
     158,
     -429,
     1103,
     1062
    ],
    "À": [
     1366,
     667,
     -3,
     0,
     1369,
     1836
    ],
    "Á": [
     1366,
     667,
     -3,
     0,
     1369,
     1836
    ],
    "Â": [
     1366,
     667,
     -3,
     0,
     1369,
     1836
    ],
    "Ã": [
     1366,
     667,
     -3,
     0,
     1369,
     1787
    ],
    "Ä": [
     1366,
     667,
     -3,
     0,
     1369,
     1761
    ],
    "Å": [
     1366,
     667,
     -3,
     0,
     1369,
     1780
    ],
    "Æ": [
     2048,
     1000,
     1,
     0,
     1936,
     1466
    ],
    "Ç": [
     1479,
     722,
     102,
     -421,
     1398,
     1491
    ],
    "È": [
     1366,
     667,
     162,
     0,
     1256,
     1836
    ],
    "É": [
     1366,
     667,
     162,
     0,
     1256,
     1836
    ],
    "Ê": [
     1366,
     667,
     162,
     0,
     1256,
     1836
    ],
    "Ë": [
     1366,
     667,
     162,
     0,
     1256,
     1761
    ],
    "Ì": [
     569,
     278,
     54,
     0,
     430,
     1836
    ],
    "Í": [
     569,
     278,
     141,
     0,
     510,
     1836
    ],
    "Î": [
     569,
     278,
     -32,
     0,
     601,
     1836
    ],
    "Ï": [
     569,
     278,
     4,
     0,
     565,
     1761
    ],
    "Ð": [
     1479,
     722,
     -3,
     0,
     1370,
     1466
    ],
    "Ñ": [
     1479,
     722,
     156,
     0,
     1311,
     1787
    ],
    "Ò": [
     1593,
     778,
     99,
     -25,
     1501,
     1836
    ],
    "Ó": [
     1593,
     778,
     99,
     -25,
     1501,
     1836
    ],
    "Ô": [
     1593,
     778,
     99,
     -25,
     1501,
     1836
    ],
    "Õ": [
     1593,
     778,
     99,
     -25,
     1501,
     1787
    ],
    "Ö": [
     1593,
     778,
     99,
     -25,
     1501,
     1761
    ],
    "×": [
     1196,
     584,
     161,
     288,
     1033,
     1160
    ],
    "Ø": [
     1593,
     778,
     83,
     -59,
     1517,
     1520
    ],
    "Ù": [
     1479,
     722,
     161,
     -25,
     1314,
     1836
    ],
    "Ú": [
     1479,
     722,
     161,
     -25,
     1314,
     1836
    ],
    "Û": [
     1479,
     722,
     161,
     -25,
     1314,
     1836
    ],
    "Ü": [
     1479,
     722,
     161,
     -25,
     1314,
     1761
    ],
    "Ý": [
     1366,
     667,
     6,
     0,
     1350,
     1836
    ],
    "Þ": [
     1366,
     667,
     158,
     0,
     1277,
     1466
    ],
    "ß": [
     1251,
     611,
     153,
     -25,
     1187,
     1491
    ],
    "à": [
     1139,
     556,
     74,
     -24,
     1052,
     1474
    ],
    "á": [
     1139,
     556,
     74,
     -24,
     1052,
     1474
    ],
    "â": [
     1139,
     556,
     74,
     -24,
     1052,
     1474
    ],
    "ã": [
     1139,
     556,
     74,
     -24,
     1052,
     1450
    ],
    "ä": [
     1139,
     556,
     74,
     -24,
     1052,
     1475
    ],
    "å": [
     1139,
     556,
     74,
     -24,
     1052,
     1517
    ],
    "æ": [
     1821,
     889,
     68,
     -24,
     1738,
     1086
    ],
    "ç": [
     1024,
     500,
     80,
     -401,
     1005,
     1086
    ],
    "è": [
     1139,
     556,
     75,
     -24,
     1054,
     1474
    ],
    "é": [
     1139,
     556,
     75,
     -24,
     1054,
     1474
    ],
    "ê": [
     1139,
     556,
     75,
     -24,
     1054,
     1474
    ],
    "ë": [
     1139,
     556,
     75,
     -24,
     1054,
     1475
    ],
    "ì": [
     569,
     278,
     35,
     0,
     411,
     1474
    ],
    "í": [
     569,
     278,
     189,
     0,
     558,
     1474
    ],
    "î": [
     569,
     278,
     -17,
     0,
     616,
     1474
    ],
    "ï": [
     569,
     278,
     9,
     0,
     570,
     1475
    ],
    "ð": [
     1139,
     556,
     73,
     -25,
     1057,
     1466
    ],
    "ñ": [
     1139,
     556,
     135,
     0,
     998,
     1450
    ],
    "ò": [
     1139,
     556,
     68,
     -24,
     1063,
     1474
    ],
    "ó": [
     1139,
     556,
     68,
     -24,
     1063,
     1474
    ],
    "ô": [
     1139,
     556,
     68,
     -24,
     1063,
     1474
    ],
    "õ": [
     1139,
     556,
     68,
     -24,
     1063,
     1450
    ],
    "ö": [
     1139,
     556,
     68,
     -24,
     1063,
     1475
    ],
    "÷": [
     1124,
     549,
     78,
     319,
     1046,
     1127
    ],
    "ø": [
     1251,
     611,
     129,
     -79,
     1124,
     1127
    ],
    "ù": [
     1139,
     556,
     131,
     -24,
     992,
     1474
    ],
    "ú": [
     1139,
     556,
     131,
     -24,
     992,
     1474
    ],
    "û": [
     1139,
     556,
     131,
     -24,
     992,
     1474
    ],
    "ü": [
     1139,
     556,
     131,
     -24,
     992,
     1475
    ],
    "ý": [
     1024,
     500,
     33,
     -431,
     1006,
     1474
    ],
    "þ": [
     1139,
     556,
     135,
     -407,
     1057,
     1466
    ],
    "ÿ": [
     1024,
     500,
     33,
     -431,
     1006,
     1475
    ],
    "Ā": [
     1366,
     667,
     -3,
     0,
     1369,
     1726
    ],
    "ā": [
     1139,
     556,
     74,
     -24,
     1052,
     1375
    ],
    "Ă": [
     1366,
     667,
     -3,
     0,
     1369,
     1815
    ],
    "ă": [
     1139,
     556,
     74,
     -24,
     1052,
     1464
    ],
    "Ą": [
     1366,
     667,
     -3,
     -430,
     1374,
     1466
    ],
    "ą": [
     1139,
     556,
     74,
     -430,
     1084,
     1086
    ],
    "Ć": [
     1479,
     722,
     102,
     -25,
     1398,
     1836
    ],
    "ć": [
     1024,
     500,
     80,
     -24,
     1005,
     1474
    ],
    "Ĉ": [
     1479,
     722,
     102,
     -25,
     1398,
     1830
    ],
    "ĉ": [
     1024,
     500,
     80,
     -24,
     1005,
     1474
    ],
    "Ċ": [
     1479,
     722,
     102,
     -25,
     1398,
     1818
    ],
    "ċ": [
     1024,
     500,
     80,
     -24,
     1005,
     1418
    ],
    "Č": [
     1479,
     722,
     102,
     -25,
     1398,
     1830
    ],
    "č": [
     1024,
     500,
     80,
     -24,
     1005,
     1474
    ],
    "Ď": [
     1479,
     722,
     158,
     0,
     1370,
     1830
    ],
    "ď": [
     1259,
     615,
     71,
     -24,
     1262,
     1466
    ],
    "Đ": [
     1479,
     722,
     -3,
     0,
     1370,
     1466
    ],
    "đ": [
     1139,
     556,
     70,
     -24,
     1136,
     1466
    ],
    "Ē": [
     1366,
     667,
     162,
     0,
     1256,
     1737
    ],
    "ē": [
     1139,
     556,
     75,
     -24,
     1054,
     1375
    ],
    "Ĕ": [
     1366,
     667,
     162,
     0,
     1256,
     1826
    ],
    "ĕ": [
     1139,
     556,
     75,
     -24,
     1054,
     1464
    ],
    "Ė": [
     1366,
     667,
     162,
     0,
     1256,
     1780
    ],
    "ė": [
     1139,
     556,
     75,
     -24,
     1054,
     1418
    ],
    "Ę": [
     1366,
     667,
     162,
     -430,
     1256,
     1466
    ],
    "ę": [
     1139,
     556,
     75,
     -430,
     1054,
     1086
    ],
    "Ě": [
     1366,
     667,
     162,
     0,
     1256,
     1830
    ],
    "ě": [
     1139,
     556,
     75,
     -24,
     1054,
     1474
    ],
    "Ĝ": [
     1593,
     778,
     109,
     -25,
     1465,
     1825
    ],
    "ĝ": [
     1139,
     556,
     66,
     -431,
     1002,
     1474
    ],
    "Ğ": [
     1593,
     778,
     109,
     -25,
     1465,
     1815
    ],
    "ğ": [
     1139,
     556,
     66,
     -431,
     1002,
     1464
    ],
    "Ġ": [
     1593,
     778,
     109,
     -25,
     1465,
     1769
    ],
    "ġ": [
     1139,
     556,
     66,
     -431,
     1002,
     1418
    ],
    "Ģ": [
     1593,
     778,
     109,
     -551,
     1465,
     1491
    ],
    "ģ": [
     1139,
     556,
     66,
     -431,
     1002,
     1576
    ],
    "Ĥ": [
     1479,
     722,
     164,
     0,
     1314,
     1836
    ],
    "ĥ": [
     1139,
     556,
     135,
     0,
     1000,
     1836
    ],
    "Ħ": [
     1479,
     722,
     31,
     0,
     1447,
     1466
    ],
    "ħ": [
     1139,
     556,
     6,
     0,
     1000,
     1466
    ],
    "Ĩ": [
     569,
     278,
     -63.016949152542374,
     0,
     606,
     1812
    ],
    "ĩ": [
     569,
     278,
     -45.016949152542374,
     0,
     624,
     1450
    ],
    "Ī": [
     569,
     278,
     -28,
     0,
     596,
     1711
    ],
    "ī": [
     569,
     278,
     -23,
     0,
     601,
     1375
    ],
    "Ĭ": [
     569,
     278,
     -1,
     0,
     590,
     1800
    ],
    "ĭ": [
     569,
     278,
     -6,
     0,
     585,
     1464
    ],
    "Į": [
     569,
     278,
     75,
     -430,
     414,
     1466
    ],
    "į": [
     455,
     222,
     25,
     -430,
     364,
     1466
    ],
    "İ": [
     569,
     278,
     177,
     0,
     400,
     1780
    ],
    "ı": [
     569,
     278,
     198,
     0,
     378,
     1062
    ],
    "Ĳ": [
     1505,
     735,
     191,
     -25,
     1400,
     1466
    ],
    "ĳ": [
     909,
     444,
     136,
     -431,
     792,
     1466
    ],
    "Ĵ": [
     1024,
     500,
     58.84976525821597,
     -25,
     1108,
     1836
    ],
    "ĵ": [
     455,
     222,
     -94,
     -431,
     544,
     1474
    ],
    "Ķ": [
     1366,
     667,
     150,
     -551,
     1362,
     1466
    ],
    "ķ": [
     1024,
     500,
     136,
     -551,
     1016,
     1466
    ],
    "ĸ": [
     1024,
     500,
     134,
     0,
     1014,
     1062
    ],
    "Ĺ": [
     1139,
     556,
     150,
     0,
     1066,
     1836
    ],
    "ĺ": [
     455,
     222,
     66,
     0,
     435,
     1821
    ],
    "Ļ": [
     1139,
     556,
     150,
     -551,
     1066,
     1466
    ],
    "ļ": [
     455,
     222,
     106,
     -551,
     328,
     1466
    ],
    "Ľ": [
     1139,
     556,
     150,
     0,
     1066,
     1466
    ],
    "ľ": [
     597,
     292,
     136,
     0,
     596,
     1466
    ],
    "Ŀ": [
     1139,
     556,
     150,
     0,
     1066,
     1466
    ],
    "ŀ": [
     684,
     334,
     131,
     0,
     665,
     1466
    ],
    "Ł": [
     1139,
     556,
     0,
     0,
     1067,
     1466
    ],
    "ł": [
     455,
     222,
     3,
     0,
     447,
     1466
    ],
    "Ń": [
     1479,
     722,
     156,
     0,
     1311,
     1836
    ],
    "ń": [
     1139,
     556,
     135,
     0,
     998,
     1474
    ],
    "Ņ": [
     1479,
     722,
     156,
     -551,
     1311,
     1466
    ],
    "ņ": [
     1139,
     556,
     135,
     -551,
     998,
     1086
    ],
    "Ň": [
     1479,
     722,
     156,
     0,
     1311,
     1836
    ],
    "ň": [
     1139,
     556,
     135,
     0,
     998,
     1474
    ],
    "ŉ": [
     1237,
     604,
     -38,
     0,
     1096,
     1481
    ],
    "Ŋ": [
     1481,
     723,
     165,
     -25,
     1373,
     1491
    ],
    "ŋ": [
     1139,
     556,
     139,
     -431,
     1002,
     1086
    ],
    "Ō": [
     1593,
     778,
     99,
     -25,
     1501,
     1747
    ],
    "ō": [
     1139,
     556,
     68,
     -24,
     1063,
     1375
    ],
    "Ŏ": [
     1593,
     778,
     99,
     -25,
     1501,
     1826
    ],
    "ŏ": [
     1139,
     556,
     68,
     -24,
     1063,
     1464
    ],
    "Ő": [
     1593,
     778,
     99,
     -25,
     1501,
     1836
    ],
    "ő": [
     1139,
     556,
     68,
     -24,
     1063,
     1474
    ],
    "Œ": [
     2048,
     1000,
     129,
     -25,
     1983,
     1491
    ],
    "œ": [
     1933,
     944,
     82,
     -24,
     1857.0289855072465,
     1086
    ],
    "Ŕ": [
     1479,
     722,
     161,
     0,
     1453,
     1836
    ],
    "ŕ": [
     682,
     333,
     133,
     0,
     710,
     1474
    ],
    "Ŗ": [
     1479,
     722,
     161,
     -551,
     1453,
     1466
    ],
    "ŗ": [
     682,
     333,
     106,
     -551,
     710,
     1086
    ],
    "Ř": [
     1479,
     722,
     161,
     0,
     1453,
     1830
    ],
    "ř": [
     682,
     333,
     60,
     0,
     710,
     1474
    ],
    "Ś": [
     1366,
     667,
     92,
     -25,
     1259,
     1836
    ],
    "ś": [
     1024,
     500,
     63,
     -24,
     945,
     1474
    ],
    "Ŝ": [
     1366,
     667,
     92,
     -25,
     1259,
     1830
    ],
    "ŝ": [
     1024,
     500,
     63,
     -24,
     945,
     1474
    ],
    "Ş": [
     1366,
     667,
     92,
     -411,
     1259,
     1491
    ],
    "ş": [
     1024,
     500,
     63,
     -401,
     945,
     1086
    ],
    "Š": [
     1366,
     667,
     92,
     -25,
     1259,
     1830
    ],
    "š": [
     1024,
     500,
     63,
     -24,
     945,
     1474
    ],
    "Ţ": [
     1251,
     611,
     48,
     -421,
     1210,
     1466
    ],
    "ţ": [
     569,
     278,
     36,
     -421,
     600,
     1433
    ],
    "Ť": [
     1251,
     611,
     48,
     0,
     1210,
     1830
    ],
    "ť": [
     768,
     375,
     35,
     -14,
     765,
     1466
    ],
    "Ŧ": [
     1251,
     611,
     48,
     0,
     1210,
     1466
    ],
    "ŧ": [
     569,
     278,
     12,
     -14,
     531,
     1433
    ],
    "Ũ": [
     1479,
     722,
     161,
     -25,
     1314,
     1806
    ],
    "ũ": [
     1139,
     556,
     131,
     -24,
     992,
     1450
    ],
    "Ū": [
     1479,
     722,
     161,
     -25,
     1314,
     1731
    ],
    "ū": [
     1139,
     556,
     131,
     -24,
     992,
     1375
    ],
    "Ŭ": [
     1479,
     722,
     161,
     -25,
     1314,
     1820
    ],
    "ŭ": [
     1139,
     556,
     131,
     -24,
     992,
     1464
    ],
    "Ů": [
     1479,
     722,
     161,
     -25,
     1314,
     1835
    ],
    "ů": [
     1139,
     556,
     131,
     -24,
     992,
     1517
    ],
    "Ű": [
     1479,
     722,
     161,
     -25,
     1314,
     1836
    ],
    "ű": [
     1139,
     556,
     131,
     -24,
     992,
     1474
    ],
    "Ų": [
     1479,
     722,
     161,
     -430,
     1314,
     1466
    ],
    "ų": [
     1139,
     556,
     131,
     -430,
     1045,
     1062
    ],
    "Ŵ": [
     1933,
     944,
     25,
     0,
     1910,
     1836
    ],
    "ŵ": [
     1479,
     722,
     6,
     0,
     1463,
     1474
    ],
    "Ŷ": [
     1366,
     667,
     6,
     0,
     1350,
     1836
    ],
    "ŷ": [
     1024,
     500,
     33,
     -431,
     1006,
     1474
    ],
    "Ÿ": [
     1366,
     667,
     6,
     0,
     1350,
     1761
    ],
    "Ź": [
     1251,
     611,
     41,
     0,
     1200,
     1836
    ],
    "ź": [
     1024,
     500,
     40,
     0,
     980,
     1474
    ],
    "Ż": [
     1251,
     611,
     41,
     0,
     1200,
     1780
    ],
    "ż": [
     1024,
     500,
     40,
     0,
     980,
     1418
    ],
    "Ž": [
     1251,
     611,
     41,
     0,
     1200,
     1830
    ],
    "ž": [
     1024,
     500,
     40,
     0,
     980,
     1474
    ],
    "ſ": [
     455,
     222,
     137,
     0,
     598,
     1491
    ],
    "–": [
     1139,
     556,
     -4,
     458,
     1135,
     603
    ],
    "—": [
     2048,
     1000,
     0,
     458,
     2048,
     603
    ],
    "‘": [
     455,
     222,
     128,
     1011,
     337,
     1491
    ],
    "’": [
     455,
     222,
     108,
     1001,
     317,
     1481
    ],
    "‚": [
     455,
     222,
     108,
     -271,
     317,
     209
    ],
    "‛": [
     455,
     222,
     138,
     1001,
     347,
     1481
    ],
    "“": [
     682,
     333,
     83,
     1011,
     602,
     1491
    ],
    "”": [
     682,
     333,
     71,
     1001,
     590,
     1481
    ],
    "„": [
     682,
     333,
     71,
     -271,
     590,
     209
    ],
    "†": [
     1139,
     556,
     73,
     -346,
     1054,
     1432
    ],
    "‡": [
     1139,
     556,
     73,
     -346,
     1058,
     1446
    ],
    "•": [
     717,
     350,
     109,
     464,
     616,
     971
    ],
    "…": [
     2048,
     1000,
     239,
     0,
     1810,
     205
    ],
    "‰": [
     2048,
     1000,
     37,
     -54,
     2011,
     1491
    ],
    "′": [
     384,
     188,
     128,
     947,
     398,
     1466
    ],
    "″": [
     725,
     354,
     128,
     947,
     681,
     1466
    ],
    "‹": [
     682,
     333,
     92,
     72,
     556,
     984
    ],
    "›": [
     682,
     333,
     92,
     72,
     545,
     984
    ],
    "€": [
     1139,
     556,
     -28,
     -25,
     1107,
     1491
    ],
    "№": [
     2197,
     1073,
     160,
     0,
     2112,
     1466
    ],
    "™": [
     2048,
     1000,
     225,
     651,
     1783,
     1466
    ]
   }
  }
 }
}
;
// BB_LAYOUT_PACK_END
